export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('scrollToSmoothly', (target, attr = 'id', duration = 300) => {
    let startTime = null;
    const startPosition = window.scrollY;
    const offsetPosition = document.querySelector('header')?.offsetHeight ?? 0;

    const getTargetPosition = () => {
      if (target instanceof Element) {
        return target.getBoundingClientRect().top + startPosition - offsetPosition;
      }
      if (!isNaN(+target) && typeof +target === 'number') {
        return +target;
      }

      const selector = attr === 'class' ? '.' : attr === 'tag' ? '' : '#';
      const element = document.querySelector(`${selector}${target}`);
      return element ? element.getBoundingClientRect().top + startPosition : null;
    };

    const distance = getTargetPosition() - startPosition - offsetPosition;

    const animation = currentTime => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easeInOutCubic = t =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      const run = easeInOutCubic(progress);
      window.scrollTo(0, startPosition + distance * run);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  });
});
